import React from 'react';
import {useCompleteInspectionContext} from '../../../CompleteInspectionContext';
import {getSelectedOptionLabel} from '../../../../utils/options';
import {
  presenterGenderFirstLabelOptions,
  presenterGenderSecondLabelOptions,
  presenterGenderThirdLabelOptions,
  presentorAssociationOptions,
  presentorIdTypeOptions
} from '../../../../../../common/constants/options';

const PresenterDetails = () => {
  const {
    data: {
      pdfData: {
        presentorName,
        presentorGender,
        presentorIDNumber,
        presentorAssociation,
        presentorIDType
      },
    }
  } = useCompleteInspectionContext();

  const firstGenderLabel = getSelectedOptionLabel(presentorGender, presenterGenderFirstLabelOptions);
  const secondGenderLabel = getSelectedOptionLabel(presentorGender, presenterGenderSecondLabelOptions);
  const thirdGenderLabel = getSelectedOptionLabel(presentorGender, presenterGenderThirdLabelOptions);
  const presentorAssociationValue = getSelectedOptionLabel(presentorAssociation, presentorAssociationOptions);
  const presentorIdTypeValue = getSelectedOptionLabel(presentorIDType, presentorIdTypeOptions);

  return Boolean(presentorName)
    ? (
      <span>
        {[
          'בנוכחות',
          presentorName,
          firstGenderLabel,
          'אשר זוהה על ידי',
          presentorIdTypeValue,
          Boolean(presentorIDNumber)
            ? ['מספר', `${secondGenderLabel}.`].join(' ')
            : '',
          'זיקתו של המציג לנכס:',
          presentorAssociationValue,
          thirdGenderLabel
        ].join(' ')}.
      </span>
    )
    : (
      <span>, בידיעת מזמין חוות הדעת נערך ביקור בנכס ללא נוכחות נציג.</span>
    );
};

export default PresenterDetails;
